<ng-container *ngIf="displayFormula()">
  <ng-container *ngIf="displayPriceOnly()">
    <div [ngClass]="styleClass">{{ price }}</div>
  </ng-container>
  <ng-container *ngIf="displayQuantityAndPrice()">
    <div class="cx-quantity-price">
      {{ quantityWithPrice(formula?.quantity | cxNumeric) }}
    </div>
    <div class="cx-price-total">{{ priceTotal }}</div>
  </ng-container>
</ng-container>
